import { Box, styled, TextField } from '@mui/material';
import { Link } from 'react-router-dom';

export const MenuItemTitle = styled(Box)`
  display: flex;
  padding: ${(p) => p.theme.spacing(0.5)} ${(p) => p.theme.spacing(1.5)};
  border-bottom: 1px solid ${(p) => p.theme.palette.grey[300]};
`;

export const MenuLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: ${(p) => p.theme.spacing(0.5)} ${(p) => p.theme.spacing(2)};
  font-size: ${(p) => p.theme.typography.body2};
  gap: ${(p) => p.theme.spacing(2)};
  color: ${(p) => p.theme.palette.common.black};

  :hover {
    background-color: ${(p) => p.theme.palette.primary[100]};
    color: ${(p) => p.theme.palette.common.black};
  }
`;

export const SearchInput = styled(TextField)`
  padding: ${(p) => p.theme.spacing(1.5)} ${(p) => p.theme.spacing(2)};
  width: 100%;

  & > .MuiInputBase-root:hover,
  .MuiInputBase-root:focus-visible {
    & > .MuiOutlinedInput-notchedOutline {
      border-color: ${(p) => p.theme.palette.primary[400]};
    }
  }
`;
